var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"splitview",staticClass:"smart splitview",class:( _obj = {open:_vm.paneOpen, hover:_vm.hoverOpen}, _obj[_vm.modeClass] = true, _obj )},[_c('div',{staticClass:"pane"},[_vm._t("pane")],2),_c('div',{staticClass:"content"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }